<template>
  <div class="p-2 bg-[#F9F9FB] border border-grayNeutralLight rounded">
    <svg width="16" height="16">
      <use :xlink:href="`#${icon}`"></use>
    </svg>
  </div>
</template>
<script>
export default {
  name: 'IconBox',
  props: {
    icon: {
      type: String,
      required: true,
      default: '',
    },
  },
}
</script>
